export default __webpack_public_path__ + "static/media/adi.45b3df5f.jpg";